<template>
  <div>
    <!--        <button @click="testMethod()">Click</button>-->
    <notifications group="main" position="bottom right">
      <template slot="body" slot-scope="props">
        <div
          class="app-vue-notification"
          :class="{
            ['warn']: props.item.type === 'warn',
            ['error']: props.item.type === 'error',
            ['success']: props.item.type === 'success',
          }"
        >
          <span class="md-body-1" style="color: white">
            {{ props.item.title }}
          </span>
          <span style="float: right" @click="props.close">
            <md-icon>close</md-icon>
          </span>
          <div>
            {{ props.item.text }}
          </div>
        </div>
      </template>
    </notifications>
  </div>
</template>

<script>
import { EventBus, Topics, Types } from '@/event-bus'

export default {
  name: 'NotificationsApp',
  data() {
    return {
      notifications: [],
      canRemove: true,
      eventScheduler: null,
      types: Types,
    }
  },
  mounted() {
    EventBus.$on(Topics.NOTIFICATIONS, (data) => {
      const mensagem = Array.isArray(data.message)
        ? data.message
            .map((item) => (Array.isArray(item) ? item[0] : item) + '\n')
            .join()
        : data.message

      this.$notify({
        group: 'main',
        title: data.title || 'Mensagem',
        text: mensagem,
        type: data.type,
        duration: 7000,
        speed: 600,
        position: 'bottom right',
      })
    })
  },
}
</script>

<style lang="scss">
.app-vue-notification {
  padding: 10px;
  margin: 0 5px 5px;

  font-size: 14px;

  color: #ffffff;
  background: #44a4fc;
  border-left: 5px solid #187fe7;

  &.warn {
    background: #ffb648;
    border-left-color: #f48a06;
  }

  &.error {
    background: #e54d42;
    border-left-color: #b82e24;
  }

  &.success {
    background: #68cd86;
    border-left-color: #42a85f;
  }
}
</style>
